interface ConfirmStartConsultationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  patientNom: string;
}

export default function ConfirmStartConsultationModal({
  isOpen,
  onClose,
  onConfirm,
  patientNom
}: ConfirmStartConsultationModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full">
        <div className="p-4 sm:p-6">
          <div className="w-14 h-14 sm:w-16 sm:h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-question-line text-2xl sm:text-3xl text-blue-600"></i>
          </div>
          
          <h2 className="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-3">
            Démarrer la consultation ?
          </h2>
          
          <p className="text-center text-gray-600 mb-6 text-sm sm:text-base px-2">
            Êtes-vous sûr de vouloir démarrer la consultation avec <strong>{patientNom}</strong> ?
            <br />
            <span className="text-xs sm:text-sm text-gray-500 mt-2 block">
              L'heure de début sera enregistrée automatiquement.
            </span>
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={onClose}
              className="flex-1 px-4 sm:px-6 py-2 sm:py-3 border-2 border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 transition-colors font-semibold whitespace-nowrap cursor-pointer text-sm"
            >
              Annuler
            </button>
            <button
              onClick={onConfirm}
              className="flex-1 px-4 sm:px-6 py-2 sm:py-3 bg-clinic-blue text-white rounded-xl hover:bg-clinic-blue-dark transition-colors font-semibold whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-play-circle-line mr-2"></i>
              Confirmer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
